<template>
  <b-container class="search-area" fluid="lg">
    <div class="mb-5">
      <b-form-row class="mb-3">
        <b-col>
          <h3 class="common__search-title">Academic Year</h3>
          <FiscalYear v-model="conditions.fiscalYear" />
        </b-col>
        <b-col>
          <h3 class="common__search-title">Semester</h3>
          <Semester v-model="conditions.semester" />
        </b-col>
        <b-col>
          <h3 class="common__search-title">University</h3>
          <University v-model="conditions.university" />
        </b-col>
      </b-form-row>

      <b-form-row class="mb-3">
        <b-col>
          <h3 class="common__search-title">Student Number</h3>
          <input type="text" v-model="conditions.studentNumber" />
        </b-col>
        <b-col>
          <h3 class="common__search-title">Student Name</h3>
          <input type="text" v-model="conditions.studentNameJapanese" />
        </b-col>
        <b-col>
          <h3 class="common__search-title">Student Name (Alphabet)</h3>
          <input type="text" v-model="conditions.studentName" />
        </b-col>
      </b-form-row>

      <b-form-row class="mb-3">
        <b-col cols="4">
          <h3 class="common__search-title">Email</h3>
          <input type="text" v-model="conditions.email">
        </b-col>
      </b-form-row>

      <b-form-row class="mb-3">
        <b-col cols="4">
          <h3 class="common__search-title">Course Name</h3>
          <input type="text" v-model="conditions.courseName">
        </b-col>
        <b-col>
          <div>
            <h3 class="common__search-title">Level</h3>
            <Levels v-model="conditions.levels" />
          </div>
          <div>
            <h3 class="common__search-title">Day of the week</h3>
            <Weekdays v-model="conditions.dayOfWeeks" />
          </div>
          <div>
            <h3 class="common__search-title">period</h3>
            <Periods v-model="conditions.periods" />
          </div>
        </b-col>
      </b-form-row>

      <b-form-row class="mb-3">
        <b-col cols="4">
          <h3 class="common__search-title">Tutor ID</h3>
          <input type="text" v-model="conditions.tutorId" />
        </b-col>
        <b-col cols="4">
          <h3 class="common__search-title">Tutor name</h3>
          <input type="text" v-model="conditions.tutorName" />
        </b-col>
      </b-form-row>

      <b-form-row class="mb-3">
        <b-col v-show="conditions.university && conditions.university.code === '01'">
          <h3 class="common__search-title">campus</h3>
          <Campuses
            v-model="conditions.campuses"
            :belongsToUniversity="conditions.university"
          />
        </b-col>
        <b-col cols="4">
          <h3 class="common__search-title">Classroom</h3>
          <input type="text" v-model="conditions.classroom" />
        </b-col>
        <b-col cols="4">
          <h3 class="common__search-title">Booth</h3>
          <input type="text" v-model="conditions.booth" />
        </b-col>
      </b-form-row>

      <b-form-row class="mb-3">
        <b-col>
          <h3 class="common__search-title">Special consideration</h3>
          <SelectSpecialConsiderationInput v-model="conditions.specialConsideration" />
        </b-col>
        <b-col>
          <b-row>
            <b-col cols="4">
              <h3 class="common__search-title">SPIR</h3>
              <div>
                <label class="checkbox">
                  <input type="checkbox" v-model="conditions.isSpir">
                </label>
              </div>
            </b-col>
            <b-col cols="8">
              <h3 class="common__search-title">Change grade</h3>
              <div>
                <label class="checkbox">
                  <input type="checkbox" v-model="conditions.isChangeGrade">
                </label>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <h3 class="common__search-title">Old student number</h3>
          <input type="text" v-model="conditions.oldStudentNumber" />
        </b-col>
      </b-form-row>
    </div>
    <div class="d-flex justify-content-end">
      <b-button
        pill
        variant="secondary"
        @click="reset"
        class="mr-2"
      >
        Reset
      </b-button>
      <b-button
        pill
        variant="primary"
        @click="search"
      >
        Search
      </b-button>
    </div>
  </b-container>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import _ from 'lodash'

import { StudentConditions } from '@/store/students/types'

import FiscalYear from '@/components/parts/inputItem/FiscalYearInput.vue';
import Levels from '@/components/parts/inputItem/LevelsInput.vue';
import Periods from '@/components/parts/inputItem/PeriodsInput.vue';
import Campuses from '@/components/parts/inputItem/CampusesInput.vue';
import Semester from '@/components/parts/inputItem/SemesterInput.vue';
import Weekdays from '@/components/parts/inputItem/WeekdaysInput.vue';
import University from '@/components/parts/inputItem/SelectUniversityInput.vue';
import SelectSpecialConsiderationInput from '@/components/parts/inputItem/SelectSpecialConsiderationInput.vue'

export default Vue.extend({
  props: {
    initialConditions: {
      type: Object as PropType<StudentConditions>,
    },
  },
  components: {
    FiscalYear,
    Levels,
    Periods,
    Campuses,
    Semester,
    Weekdays,
    University,
    SelectSpecialConsiderationInput,
  },

  data: (): { conditions: StudentConditions } => ({
    conditions: {
      fiscalYear: null,
      semester: null,
      university: null,
      studentNumber: null,
      studentNameJapanese: null,
      studentName: null,
      email: null,
      courseName: null,
      levels: [],
      dayOfWeeks: [],
      periods: [],
      tutorId: null,
      tutorName: null,
      campuses: [],
      classroom: null,
      booth: null,
      specialConsideration: null,
      oldStudentNumber: null,
      isSpir: false,
      isChangeGrade: false,
    },
  }),

  methods: {
    search() {
      this.$emit('changeConditions', this.conditions)
    },
    reset() {
      this.$emit('changeConditions', this.initialConditions)
    },
  },
});

</script>

<style scoped>
.search-area {
  background: #D8D8D8;
  padding-top:20px;
  padding-bottom: 20px;
  position: relative;
}

input[type="text"], select{
  padding: 5px;
  border: 1px solid #AAAFB6;
  border-radius: 30px;
  width: 100%;
  max-width: 200px;
  height:30px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

input[type="checkbox"] {
  margin-right:8px;
  vertical-align: middle;
}

.checkbox {
  margin-right:40px;
}
</style>
